module.exports = __webpack_public_path__ + "static/media/fractal2.223b0497.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/example/maps/fractal2.jpg
// module id = 371
// module chunks = 0